import { Tag, TagLabel, Box, Tooltip, TagProps, List } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useSelector } from 'react-redux';
import { ISummaryIntakes, ITag } from 'types';
import { parseDate, isBefore } from 'shared-components';
import { getOfferOrIntakeMode } from '../../../../store/config/selectors';
import { useTranslation } from "react-i18next";

export type ProcessingMode = 'Offer' | 'Intake';
interface IMultiTagHoverProps {
  isActiveIntake: boolean | undefined;
  multiIntakeTagData: ISummaryIntakes[] | undefined;
  label: ProcessingMode;
}

const MultiIntakeTagHover = ({ isActiveIntake, multiIntakeTagData, label }: IMultiTagHoverProps) => {
    const { t } = useTranslation('common');
  const hasActiveIntake = multiIntakeTagData?.some(intake => intake.isActive);

  const intakesList = multiIntakeTagData?.sort(sortIntakeByStartDate).map((intake: ISummaryIntakes, index: number) => (
    <div key={`${intake.intakeId}#${intake.offerId}-${index}`}>
      <Box as="span" color="whiteAlpha.600" mr="1">
        {intake.isActive ? (
          <Box as="span" color="green.300">
            <FontAwesomeIcon icon={regular('check-circle')} />
          </Box>
        ) : (
          <FontAwesomeIcon icon={regular('circle')} />
        )}
      </Box>
      {intake.intakeLabel} - {intake.casStatus}
    </div>
  ));

  return (
    <>
      {/* This code is not great but it is a stop gap before moving to an accordian interface, see tickets DTM-12 and DTM-52 for clarity on display cases */}
      {multiIntakeTagData && multiIntakeTagData.length > 0 && (
        <Box>{label === 'Intake' ? 'The student exists in multiple intakes' : 'This student has multiple offers'}</Box>
      )}
      {!hasActiveIntake && <Box>{t('common:theStudentAgentHasNotYetSelected')} {label.toLowerCase()}</Box>}
      {isActiveIntake && <Box>{t('common:this')} {label.toLowerCase()} {t('common:hasBeenSelectedByTheStudentAgent')}</Box>}
      {!isActiveIntake && hasActiveIntake && (
        <Box>{t('common:aDifferent')} {label.toLowerCase()} {t('common:hasBeenSelectedByTheStudentAgent')}</Box>
      )}
      {intakesList?.length && <List>{intakesList}</List>}
    </>
  );
};

export const MultiIntakeTag = ({ tag, tagProps }: { tag: ITag; tagProps?: TagProps }) => {
  const isActiveIntake = !!tag.multiIntakeTagData?.find(intake => `${intake.intakeId}#${intake.offerId}` === tag.id)
    ?.isActive;

  const offerOrIntakeMode = useSelector(getOfferOrIntakeMode);
  return (
    <Tooltip
      hasArrow
      placement="bottom"
      label={
        <MultiIntakeTagHover
          isActiveIntake={isActiveIntake}
          multiIntakeTagData={tag.multiIntakeTagData}
          label={offerOrIntakeMode}
        />
      }
      data-selector="tag-multi-intake"
    >
      <Tag size="xs" variant="solid" {...tagProps}>
        <Box mr="0.5" className="star-container">
          {isActiveIntake ? (
            <FontAwesomeIcon icon={regular('check-circle')} />
          ) : (
            <FontAwesomeIcon icon={regular('circle')} />
          )}
        </Box>

        <TagLabel>{offerOrIntakeMode}</TagLabel>
      </Tag>
    </Tooltip>
  );
};

const sortIntakeByStartDate = (a: ISummaryIntakes, b: ISummaryIntakes) => {
  if (isBefore(parseDate(a.startDate), parseDate(b.startDate))) {
    return -1;
  }
  if (!isBefore(parseDate(a.startDate), parseDate(b.startDate))) {
    return 1;
  }
  return 0;
};
